import styled from 'styled-components';
import SeH004B from 'dc/SeH004B';
import Wra16A from 'dc/Wra16A';
import Btn021 from 'dc/Btn021';

export const Wrapper = styled.div`
  width: 672px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 14px 32px 32px 32px;
`;

export const Header = styled(SeH004B)`
  background-color: #f4f7f9;
`;

export const NumberWrapper = styled(Wra16A)`
  text-align: left;
  border-bottom: 1px solid rgba(38, 50, 56, 0.12);
`;

type StatsContainerProps = {
  isPlaceholder?: boolean;
};

export const StatsContainer = styled.div<StatsContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: -89px;
  width: 100%;
  min-height: 338px;
  background: ${props => (props.isPlaceholder ? '#f4f7f9' : '#fff')};
  margin-bottom: ${props => (props.isPlaceholder ? '10px' : 0)};
`;

export const TranslateWrapper = styled.div``;

export const Button = styled(Btn021)`
  padding: 0 33px;
  align-self: flex-end;
  margin-top: 12px;
`;
